import m from "./index7.js";
import { resolveComponent as a, openBlock as f, createElementBlock as y, createElementVNode as n, createVNode as r, withCtx as s, normalizeClass as c, toDisplayString as d, withModifiers as p, createTextVNode as l } from "vue";
import "./index8.js";
import C from "../../../../_virtual/index.js";
const v = { class: "country-selector-dialog" }, _ = {
  id: "country-selector-content",
  class: "country-selector-container"
}, h = { class: "country-nav-more" }, w = { class: "country-name" }, I = ["onClick"], k = ["href"], $ = { class: "country-selector-buttons-container" };
function b(o, e, g, D, M, V) {
  const u = a("DropdownMenu"), i = a("sequiter-button");
  return f(), y("div", v, [
    n("div", _, [
      n("div", h, [
        r(u, {
          menuItems: o.countryMenuItems,
          type: o.menuTypes.ExpandOnClick,
          hasArrowIcon: !0,
          showItems: o.showDropdownCountries,
          "onUpdate:showItems": e[0] || (e[0] = (t) => o.showDropdownCountries = t),
          class: "dropdown-menu-more"
        }, {
          title: s(() => [
            n("div", {
              id: "selected-country-nav-link",
              class: c(["country-nav-link footer-current-country current-country", "flag flag-" + o.selectedCountry.countryCode])
            }, [
              n("span", w, d(o.t(`countries.${o.selectedCountry.name}`)), 1)
            ], 2)
          ]),
          "country-dropdown-menu-item": s((t) => [
            n("div", {
              onClick: p((E) => o.setSelectedCountry(t.menuItem.additionalInfo), ["prevent"])
            }, [
              n("a", {
                href: t.menuItem.additionalInfo.canonicalUrl,
                class: c([
                  "country-nav-link",
                  "flag flag-" + t.menuItem.additionalInfo.countryCode
                ])
              }, d(o.t(`countries.${t.menuItem.additionalInfo.name}`)), 11, k)
            ], 8, I)
          ]),
          _: 1
        }, 8, ["menuItems", "type", "showItems"])
      ]),
      n("div", $, [
        r(i, {
          class: "continue-to-site-button",
          onClick: o.selectedCountryLink,
          variant: o.buttonVariants.PRIMARY
        }, {
          default: s(() => [
            l("Continue to site")
          ]),
          _: 1
        }, 8, ["onClick", "variant"]),
        r(i, {
          variant: o.buttonVariants.SECONDARY,
          onClick: e[1] || (e[1] = (t) => o.$emit("close"))
        }, {
          default: s(() => [
            l(" Cancel ")
          ]),
          _: 1
        }, 8, ["variant"])
      ])
    ])
  ]);
}
const q = /* @__PURE__ */ C(m, [["render", b], ["__scopeId", "data-v-1ff394df"]]);
export {
  q as default
};
//# sourceMappingURL=index6.js.map
